var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4 -3.586)"},[React.createElement("line",{"x1":"14","transform":"translate(5 12)","fill":"none","stroke":"#054a91","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M12,19,5,12l7-7","fill":"none","stroke":"#054a91","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

ArrowLeft.defaultProps = {"width":"16","height":"16.828","viewBox":"0 0 16 16.828"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
